import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PayoutService from "../../../../../services/payout.service";
import Button from "../../../../../components/Button";
import Toast from "../../../../../components/Toast";
import { APP_SUCCESS_MESSAGES } from "../../../../../utils/appConstant";

interface HeaderProps {
  onRefresh?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onRefresh }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSyncPayoutClick = useCallback(async (event?: React.FormEvent) => {
    event && event.preventDefault();
    setLoading(true);

    try {
      let response: any = await PayoutService.sync();

      if (response?.success !== false) {
        toast.success(<Toast message={APP_SUCCESS_MESSAGES.syncPayoutDispatched} />, { icon: false });
      }

      setTimeout(() => {
        setLoading(false);
        onRefresh && onRefresh();
      }, 90 * 1000);
    } catch (e) {
      setLoading(false);
    }
  }, [onRefresh]);

  const handleRefreshClick = useCallback(() => {
    onRefresh && onRefresh();
  }, [onRefresh]);

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('reconciliation.payout.list.pageTexts.header.title')}</h4>
        <p>{t('reconciliation.payout.list.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        <Button
          className="btn btn-primary waves-effect waves-light"
          onClick={handleSyncPayoutClick}
          loading={loading}
          text={t("reconciliation.payout.list.pageTexts.header.syncPayoutsButton")}
        />
      </div>
    </div>
  );
};

export default Header;
